import { z } from "zod";
import { BuildingSchema } from "./building";

const dateTransform = z.preprocess(
  (val) => (val ? new Date(val as string) : null),
  z.date().nullable()
);

export const ClientSchema = z.object({
  cid: z.number(),
  cuid: z.number().nullable().optional(),
  cadate: dateTransform,
  cedate: dateTransform,
  ctype: z.string().nullable().optional(),
  cstatus: z.string().max(16).nullable().optional(),
  clientstatus: z.string().max(16).nullable().optional(),
  clientsubstatus: z.string().max(16).nullable().optional(),
  cismgmt: z.string().max(3).nullable().optional(),
  ccomp: z.string().max(72).nullable().optional(),
  caddr1: z.string().max(100).nullable().optional(),
  caddr2: z.string().max(100).nullable().optional(),
  ccity: z.string().max(64).nullable().optional(),
  cst: z.string().max(2).nullable().optional(),
  czip: z.number().nullable().optional(),
  cphone: z.string().nullable().optional(),
  cphonebilling: z.string().nullable().optional(),
  caltphone: z.string().nullable().optional(),
  csmsphone: z.string().nullable().optional(),
  cext: z.string().max(6).nullable().optional(),
  cfax: z.string().nullable().optional(),
  ccontact: z.string().nullable().optional(),
  ctitle: z.string().nullable().optional(),
  cemail: z.string().nullable().optional(),
  cemailAlt: z.string().nullable().optional(),
  cemailAlt2: z.string().nullable().optional(),
  cemailAlt3: z.string().nullable().optional(),
  cemailAlt4: z.string().nullable().optional(),
  cemailAlt5: z.string().nullable().optional(),
  cemailAlt6: z.string().nullable().optional(),
  ccontact2: z.string().nullable().optional(),
  ctitle2: z.string().nullable().optional(),
  cphone2: z.string().nullable().optional(),
  cext2: z.string().nullable().optional(),
  cemail2: z.string().nullable().optional(),
  cemail2cc: z.string().nullable().optional(),
  cemailbilling: z.string().nullable().optional(),
  caltemailbilling: z.string().nullable().optional(),
  curl: z.string().nullable().optional(),
  cnotes: z.string().nullable().optional(),
  cpayterms: z.string().nullable().optional(),
  cview: z.string().nullable().optional(),
  csalesid: z.number().nullable().optional(),
  creferral: z.string().nullable().optional(),
  cwon: dateTransform,
  clost: dateTransform,
  cqbid: z.number().nullable().optional(),
  cqbresp: z.string().nullable().optional(),
  clatefee: z.number().nullable().optional(),
  cwaivelate: z.string().nullable().optional(),
  clotid: z.number().nullable().optional(),
  cinid: z.number().nullable().optional(),
  capp: z.number().nullable().optional(),
  cinvpays: z.string().nullable().optional(),
  cstatus2: z.string().nullable().optional(),
  cstatusuid: z.number().nullable().optional(),
  cstatusreason: z.string().nullable().optional(),
  cstatusdate: dateTransform,
  clatlon: z.string().nullable().optional(),
  cnnote: z.string().nullable().optional(),
  cinspection: dateTransform,
  clastcontact: dateTransform,
  clastcontactuid: z.number().nullable().optional(),
  ccontactmeth: z.string().nullable().optional(),
  buildings: z.array(z.object(BuildingSchema.shape)).nullable().optional()
});

// Create schemas (omit auto-generated fields)
export const CreateClientSchema = ClientSchema.omit({ cid: true });

// Update schemas (make all fields optional except ID)
export const UpdateClientSchema = ClientSchema.partial().required({ cid: true });

// Client Lost schema for the putClientLost endpoint
export const ClientLostSchema = z.object({
  clost: dateTransform,
  cstatus: z.string().nullable().optional(),
  cstatusreason: z.string().nullable().optional()
});

// Type definitions
export type Client = z.infer<typeof ClientSchema>;
export type CreateClient = z.infer<typeof CreateClientSchema>;
export type UpdateClient = z.infer<typeof UpdateClientSchema>;
export type ClientLost = z.infer<typeof ClientLostSchema>; 